import * as types from './facilityCustomViewActionType';

// Get Facility Custom View Fields
export const getFacilityCustomViewFieldsRequest = (viewId) => ({
    type: types.GET_FACILITY_CUSTOM_VIEW_FIELDS_REQUEST,
    payload: viewId
});

export const getFacilityCustomViewFieldsSuccess = (payload) => ({
    type: types.GET_FACILITY_CUSTOM_VIEW_FIELDS_SUCCESS,
    payload
});

export const getFacilityCustomViewFieldsFailure = (payload) => ({
    type: types.GET_FACILITY_CUSTOM_VIEW_FIELDS_FAILURE,
    payload
});

// Save Facility Custom View
export const saveFacilityCustomViewRequest = (payload) => ({
    type: types.SAVE_FACILITY_CUSTOM_VIEW_REQUEST,
    payload
});

export const saveFacilityCustomViewSuccess = (payload) => ({
    type: types.SAVE_FACILITY_CUSTOM_VIEW_SUCCESS,
    payload
});

export const saveFacilityCustomViewFailure = (payload) => ({
    type: types.SAVE_FACILITY_CUSTOM_VIEW_FAILURE,
    payload
});

export const saveFacilityCustomViewReset = () => ({
    type: types.SAVE_FACILITY_CUSTOM_VIEW_RESET
});


export const fetchSiteCustomViewsRequest = () => ({
  type: types.FETCH_SITE_CUSTOM_VIEWS_REQUEST,
});

export const fetchSiteCustomViewsSuccess = (data) => ({
  type: types.FETCH_SITE_CUSTOM_VIEWS_SUCCESS,
  payload: data,
});

export const fetchSiteCustomViewsFailure = (error) => ({
  type: types.FETCH_SITE_CUSTOM_VIEWS_FAILURE,
  payload: error,
});

export const toggleSiteCustomViewRequest = (payload) => ({ type: types.TOGGLE_SITE_CUSTOM_VIEW_REQUEST, payload });
export const toggleSiteCustomViewSuccess = (payload) => ({ type: types.TOGGLE_SITE_CUSTOM_VIEW_SUCCESS, payload });
export const toggleSiteCustomViewFailure = (payload) => ({ type: types.TOGGLE_SITE_CUSTOM_VIEW_FAILURE, payload });
export const deleteSiteCustomViewRequest = (payload) => ({ type: types.DELETE_SITE_CUSTOM_VIEW_REQUEST, payload });
export const deleteSiteCustomViewSuccess = (payload) => ({ type: types.DELETE_SITE_CUSTOM_VIEW_SUCCESS, payload });
export const deleteSiteCustomViewFailure = (payload) => ({ type: types.DELETE_SITE_CUSTOM_VIEW_FAILURE, payload });
export const fetchSiteCustomViewDataRequest = (customViewId) => ({ type: types.FETCH_SITE_CUSTOM_VIEW_DATA_REQUEST, payload: customViewId });
export const fetchSiteCustomViewDataSuccess = (payload) => ({ type: types.FETCH_SITE_CUSTOM_VIEW_DATA_SUCCESS, payload });
export const fetchSiteCustomViewDataFailure = (payload) => ({ type: types.FETCH_SITE_CUSTOM_VIEW_DATA_FAILURE, payload });

// Fetch Site Custom View Share Dropdown in ShareFacilityCustomViewModal
export const fetchSiteCustomViewShareDropdownRequest = (payload) => ({
    type: types.FETCH_SITE_CUSTOM_VIEW_SHARE_DROPDOWN_REQUEST,
    payload
});

export const fetchSiteCustomViewShareDropdownSuccess = (payload) => ({
    type: types.FETCH_SITE_CUSTOM_VIEW_SHARE_DROPDOWN_SUCCESS,
    payload
});

export const fetchSiteCustomViewShareDropdownFailure = (payload) => ({
    type: types.FETCH_SITE_CUSTOM_VIEW_SHARE_DROPDOWN_FAILURE,
    payload
});

// Save Shared Site Custom View
export const saveSharedSiteCustomViewRequest = (payload) => ({
    type: types.SAVE_SHARED_SITE_CUSTOM_VIEW_REQUEST,
    payload
});

export const saveSharedSiteCustomViewSuccess = (payload) => ({
    type: types.SAVE_SHARED_SITE_CUSTOM_VIEW_SUCCESS,
    payload
});

export const saveSharedSiteCustomViewFailure = (payload) => ({
    type: types.SAVE_SHARED_SITE_CUSTOM_VIEW_FAILURE,
    payload
});
